import { BaseHeader } from "./BaseHeader";

type LoggedOutHeaderProps = {
  showOnMobile?: boolean;
};

export function LoggedOutHeader({ showOnMobile }: LoggedOutHeaderProps) {
  return <BaseHeader showOnMobile={showOnMobile} />;
}
